// extracted by mini-css-extract-plugin
module.exports = {"embeddedVideoWrapper":"Vimeo-module--embeddedVideoWrapper--2LljF"};